<div style="width: 100%; margin-top: 12px">
  <div class="label-title qb-capitalize">
    {{type}} cashback validity<span class="qb-imp-color">*</span>
  </div>
  <mat-radio-group
    aria-labelledby="example-radio-group-label"
    class="example-radio-group"
    [(ngModel)]="walletExpiryType"
  >
    <ng-container  *ngFor="let data of walletExpiryTypes">
      <mat-radio-button
        color="primary"
        class="example-radio-button"
        *ngIf="!(data.type == 'NO_EXPIRY' && type === 'loyalty')"
        style="border: none;"
        [value]="data.type"
      >
        {{data.displayName}}
      </mat-radio-button>
    </ng-container>
    <!-- <mat-radio-button
      color="primary"
      class="example-radio-button"
      value="noExpiry"
    >
      No expiry
    </mat-radio-button>
    <mat-radio-button
      color="primary"
      class="example-radio-button"
      value="duation"
    >
      Valid for
    </mat-radio-button>
    <mat-radio-button
      color="primary"
      class="example-radio-button"
      value="validityDate"
    >
      Valid till
    </mat-radio-button> -->
  </mat-radio-group>
</div>
<div
  *ngIf="walletExpiryType === 'DURATION'"
  style="width: 100%; margin-bottom: 12px"
>
  <div class="label-subtitle">
    Number of days<span class="qb-imp-color">*</span>
  </div>
  <div style="width: 250px">
    <div>
      <div style="width: 100%; display: flex; align-items: center">
        <div
          class="formDiv2 qb-input-background"
          id="validForDays"
          style="width: 100%; display: flex"
        >
          <input
            class="formInput fontExo2 qb-input-background"
            type="text"
            min="0"
            [(ngModel)]="walletDuration.value"
            (keydown)="keypressNumber($event)"
          />
        </div>
      </div>
      <div class="fontExo2 qb-error-msg" id="DURATION-error">
        <span></span>
      </div>
    </div>
  </div>
</div>
<div *ngIf="walletExpiryType == 'FIXED_DATE'">
  <div style="width: 250px">
    <span class="label-subtitle">{{
      "OFFER_PAGE.GIFT_CODE_VALID_TILL" | i18nTranslate
    }}</span>
    <div style="width: 100%; padding-top: 4px">
      <mat-form-field appearance="fill" class="qb-full-width">
        <input
          matInput
          [matDatepicker]="picker"
          [min]="startDateMinValue"
          [formControl]="walletExpiryDate"
          readonly
          (click)="picker.open()"
          class="cursor-pointer"
        />
        <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
        <mat-datepicker #picker></mat-datepicker>
      </mat-form-field>
    </div>
    <small
      style="color: red"
      class="error-text"
      *ngIf="walletExpiryDate.hasError('required') && isClicked"
    >Please select a date</small>
  </div>
</div>
